import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import {
  setExportDialogVisibilityAction
} from '../../redux/actions/exportDialog'
import { IState } from '../../redux/state'
import { ExportDialog as ExportDialogComponent } from './ExportDialog'
import { PropsFromDispatch, PropsFromState } from './props'

const actionCreators = {
  setExportDialogVisibility: setExportDialogVisibilityAction,
}

const mapStateToProps = (state: IState): PropsFromState => {
  const { isExportDialogOpen } = state.ui
  return {
    isExportDialogOpen,
  }
}

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

// tslint:disable-next-line:variable-name
export const ExportDialog = connect(mapStateToProps, mapDispatchToProps)(ExportDialogComponent)
